function loadGoogleApi(key) {
    if ('google' in window) {
        return window.google;
    }
    (g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })
        ({ key, v: "weekly" });
    if ('google' in window) {
        return window.google;
    } else {
        throw new Error('Could not load Google API');
    }
}

async function getDistance(dm, origin, places) {
    const res = await dm.getDistanceMatrix({
        destinations: places.map(loc => ({
            lat: loc.Latitude,
            lng: loc.Longitude
        })),
        origins: [
            {
                lat: origin.geometry.location.lat(),
                lng: origin.geometry.location.lng()
            }
        ],
        travelMode: 'DRIVING',
        unitSystem: 0 // METRIC
    });

    if ('rows' in res && 0 in res.rows && 'elements' in res.rows[0]) {
        return res.rows[0].elements.map(item => item.distance.value);
    }
    console.log(res);
    throw new Error('Fout bij verwerken locatiegegevens');
}

document.addEventListener('alpine:init', async () => {
    const styles = [
        {
            "featureType": "all",
            "elementType": "labels.text",
            "stylers": [
                {
                    "color": "#878787"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f9f5ed"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#c9c9c9"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#aee0f4"
                }
            ]
        }
    ];
    const el = document.getElementById('winkel-zoeker');
    let { locaties: data } = JSON.parse(document.getElementById('winkel-locatie-data')?.textContent);
    data = data.filter(item => 'winkel' === item.MarkerType);
    const stores = Alpine.reactive(data.map(item => ({
        ...item,
        Distance: 0,
    })));

    Alpine.store('stores', {
        stores: stores || [],
        sort() {
            const data = Array.from(this.stores);
            data.sort((a, b) => a.Distance - b.Distance);
            return data;
        }
    });
    const { maps: loader } = loadGoogleApi('AIzaSyA_Zd3fb7upA9F-nVfp3CyyGcLsMmDbuzQ');
    const { Map } = await loader.importLibrary('maps');
    const { AdvancedMarkerElement } = await loader.importLibrary('marker');
    const { Autocomplete } = await loader.importLibrary('places');
    const markerIcon = document.getElementById('winkel-zoeker-icon').cloneNode();
    markerIcon.id = '';
    const map = new Map(
        el.querySelector('.google-map'),
        {
            zoom: 8,
            disableDefaultUI: true,
            zoomControl: true,
            center: {
                lat: 52.40462830874689,
                lng: 5.513132404005557
            },
            mapTypeControlOptions: {
                mapTypeIds: ["roadmap", "styled_map"],
            },
            mapId: 'DEMO_MAP_ID',
        }
    );
    map.mapTypes.set("styled_map", new loader.StyledMapType(styles));
    map.setMapTypeId("styled_map");
    // map.controls[1].push(el.querySelector('.overlay'));
    console.log(markerIcon);
    stores.forEach(loc => {
        new AdvancedMarkerElement({
            map: map,
            title: loc.Name,
            content: markerIcon.cloneNode(),
            position: {
                lat: loc.Latitude,
                lng: loc.Longitude
            }
        });
    });
    const autoComplete = new Autocomplete(
        document.getElementById('winkel-zoeker-autocomplete'),
        {
            componentRestrictions: { country: 'NL' },
            fields: ['geometry']
        }
    );
    autoComplete.addListener('place_changed', async () => {
        const place = autoComplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
            return;
        }
        const { DistanceMatrixService } = await loader.importLibrary('routes');
        const res = await getDistance(new DistanceMatrixService, place, stores);

        res.forEach((dist, i) => stores[i].Distance = (parseFloat(dist) / 1000));
        el.classList.add('search-completed');
    });
});